import {observable, action} from 'mobx';
import _ from 'lodash';
class Responce {
  // params.permit(:question_id, text:[:text, documents:[:file, :src]], attachments_attributes:[:document, :description])

  @observable data = {text: '', documents: [], attachments_attributes: [] };

  @action handleChange = data => {
    this.data = _.assign({}, data)
  };



}

export default new Responce();



// WEBPACK FOOTER //
// ./src/stores/Responce.js